import { Action, createReducer, on } from '@ngrx/store';
import { checkIfUserRemovedFailure, checkIfUserRemovedRequest, checkIfUserRemovedSuccess } from '../actions/remove-user.actions';
import { ICheckUserRemovedRequest, ICheckUserRemovedResponse } from '../models/remove-user.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';

export const checkUserRemovedFeatureKey = 'checkUserRemoved';

export interface CheckUserRemovedState {
  checkUserRemovedRequest: ICheckUserRemovedRequest;
  checkUserRemovedResponse: ICheckUserRemovedResponse;
  checkUserRemovedFailure: IGenericError<ErrorResponse>;
}

export const initialState: CheckUserRemovedState = {
  checkUserRemovedRequest: undefined,
  checkUserRemovedResponse: undefined,
  checkUserRemovedFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(checkIfUserRemovedRequest, (state, action) => ({
    ...state,
    checkUserRemovedRequest: action.request
  })),
  on(checkIfUserRemovedSuccess, (state, action) => ({
    ...state,
    checkUserRemovedResponse: action.response
  })),
  on(checkIfUserRemovedFailure, (state, action) => ({
    ...state,
    checkUserRemovedFailure: action.error
  }))
);

export const checkUserRemovedRequest = (state: CheckUserRemovedState) => state.checkUserRemovedRequest;
export const checkUserRemovedResponse = (state: CheckUserRemovedState) => {
  return state.checkUserRemovedResponse;
};
export const checkUserRemovedFailure = (state: CheckUserRemovedState) => state.checkUserRemovedFailure;
